module.exports = __webpack_public_path__ + "static/media/arrow-down.a4253d37.svg";